import React from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { KeyboardBackspace } from "@material-ui/icons";
import PropTypes from "prop-types";

import { useStyles } from "./SectionHeader.styles";

const SectionHeader = (props) => {
  const classes = useStyles();
  const ButtonWrapper = props.navigateTo ? Link : React.Fragment;
  const buttonWrapperProps = props.navigateTo
    ? {
        to: props.navigateTo,
        className: classes.underlineNone,
      }
    : {};

  return (
    <div className={props?.extraClass && props.extraClass}>
      {props.backBtn && (
        <Grid container direction="row" alignItems="center">
          <Button
            name="back"
            color="primary"
            className={classes.back}
            data-testid="back-btn"
            onClick={() => props.backBtnClbk()}
          >
            <KeyboardBackspace className={classes.icon} />
            {props.backBtnLabel}
          </Button>
        </Grid>
      )}
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={(classes.margin, props?.headClass && props.headClass)}
      >
        <Typography variant="h4" className={classes.title}>
          {props.title}
          {props.titleAddOn && (
            <div className={classes.titleAddOn}>{props.titleAddOn}</div>
          )}
        </Typography>
        <Grid>
          {props.altButton && (
            <Button
              variant="outlined"
              color="primary"
              className={classes.altButton}
              disabled={props.isAltButtonDisabled}
              onClick={() => props.altBtnClk()}
            >
              {props.altBtnIcon}
              {props.altBtnLabel}
            </Button>
          )}
          {props.button && (
            <ButtonWrapper {...buttonWrapperProps}>
              <Button
                name="event"
                variant="contained"
                color="primary"
                className={classes.button}
                disabled={props.isButtonDisabled}
                onClick={() => props.btnClbk()}
              >
                {props.btnIcon}
                {props.btnLabel}
              </Button>
            </ButtonWrapper>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

SectionHeader.propTypes = {
  extraClass: PropTypes.string,
  backBtn: PropTypes.bool,
  btnLabel: PropTypes.string,
  isButtonDisabled: PropTypes.bool,
  btnClbk: PropTypes.func,
  btnIcon: PropTypes.node,
  button: PropTypes.bool,
  title: PropTypes.node,
  titleAddOn: PropTypes.any,
  navigateTo: PropTypes.object,
  backBtnClbk: PropTypes.func,
  backBtnLabel: PropTypes.string,
  altBtnLabel: PropTypes.string,
  altBtnIcon: PropTypes.node,
  isAltButtonDisabled: PropTypes.bool,
  altBtnClk: PropTypes.func,
  altButton: PropTypes.bool,
  headClass: PropTypes.string,
};

export { SectionHeader };
